import { render, staticRenderFns } from "./SelectItems.vue?vue&type=template&id=890b24fe&scoped=true"
import script from "./SelectItems.vue?vue&type=script&lang=js"
export * from "./SelectItems.vue?vue&type=script&lang=js"
import style0 from "./SelectItems.vue?vue&type=style&index=0&id=890b24fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890b24fe",
  null
  
)

export default component.exports